export interface GoogleAnalyticsConfig {
  tracking_id: string;
}

export const GoogleAnalyticsConfigDefaults = {
  tracking_id: null,
};
